<template>
  <el-menu :default-active="defaultActive" unique-opened router active-text-color="#409eff">
 
    <div v-if="menu['data']">
      <div>
        <div v-if="menu['data'].indexOf('sp_realtime') > -1">
          <el-menu-item index="/data/sp_realtime/overview">
            <i class="fa c-icon fa-clock-o"></i>
            <span>实时</span>
          </el-menu-item>
        </div>
        <div v-if="menu['data'].indexOf('sp_v2_realtime') > -1">
          <el-menu-item index="/data/sp_v2_realtime/overview">
            <i class="fa c-icon fa-clock-o"></i>
            <span>实时v2</span>
          </el-menu-item>
        </div>
        <div v-if="menu['data'].indexOf('sp_user') > -1">
          <el-submenu index="/data/sp_user">
            <template slot="title">
              <i class="fa fa-user-circle"></i>
              <span class="menu-title">用户</span>
            </template>
            <div>
              <div><el-menu-item index="/data/sp_user/overview">概览</el-menu-item></div>
              <div><el-menu-item index="/data/sp_user/new">新增</el-menu-item></div>
              <div><el-menu-item index="/data/sp_user/details">详情</el-menu-item></div>
            </div>
          </el-submenu>
        </div>
        <div v-if="menu['data'].indexOf('sp_v2_user') > -1">
          <el-submenu index="/data/sp_v2_user">
            <template slot="title">
              <i class="fa fa-user-circle"></i>
              <span class="menu-title">用户v2</span>
            </template>
            <div>
              <div><el-menu-item index="/data/sp_v2_user/overview">概览</el-menu-item></div>
              <div><el-menu-item index="/data/sp_v2_user/new">新增</el-menu-item></div>
              <div><el-menu-item index="/data/sp_v2_user/details">详情</el-menu-item></div>
            </div>
          </el-submenu>
        </div>
        <div v-if="menu['data'].indexOf('sp_behavior') > -1">
          <el-submenu index="/data/sp_behavior">
            <template slot="title">
              <i class="fa fa-compass"></i>
              <span class="menu-title"> 行为</span>
            </template>
            <div>
              <div><el-menu-item index="/data/sp_behavior/overview">访问</el-menu-item></div>
              <div><el-menu-item index="/data/sp_behavior/share">分享</el-menu-item></div>
            </div>
          </el-submenu>
        </div>
        <div v-if="menu['data'].indexOf('sp_v2_behavior') > -1">
          <el-submenu index="/data/sp_v2_behavior">
            <template slot="title">
              <i class="fa fa-compass"></i>
              <span class="menu-title"> 行为v2</span>
            </template>
            <div>
              <div><el-menu-item index="/data/sp_v2_behavior/overview">访问</el-menu-item></div>
              <div><el-menu-item index="/data/sp_v2_behavior/share">分享</el-menu-item></div>
            </div>
          </el-submenu>
        </div>
        <div v-if="menu['data'].indexOf('dashboard') > -1">
          <el-menu-item index="/data/dashboard/home">
            <i class="fa c-icon fa-pie-chart"></i>
            <span>Dashboard</span>
          </el-menu-item>
        </div>
        <div v-if="menu['data'].indexOf('utm_data') > -1">
          <el-submenu index="/data/utm">
            <template slot="title">
              <i class="fa fa-pie-chart c-icon"></i>
              <span class="menu-title">数据相关</span>
            </template>
            <div>
              <div><el-menu-item index="/data/utm/index">京东活动数据</el-menu-item></div>
              <div><el-menu-item index="/data/utm/insight">京东店铺人群画像</el-menu-item></div>
            </div>
          </el-submenu>
        </div>
        <div v-if="menu['data'].indexOf('realtime') > -1">
          <el-menu-item index="/data/realtime/overview">
            <i class="fa c-icon fa-clock-o"></i>
            <span>实时</span>
          </el-menu-item>
        </div>
        <div v-if="menu['data'].indexOf('user') > -1">
          <el-submenu index="/data/user">
            <template slot="title">
              <i class="fa c-icon fa-user-circle"></i>
              <span>用户</span>
            </template>
            <div><el-menu-item index="/data/user/overview">概览</el-menu-item></div>
            <div><el-menu-item index="/data/user/new">新增</el-menu-item></div>
            <div><el-menu-item index="/data/user/details">详情</el-menu-item></div>
          </el-submenu>
        </div>
        <div v-if="menu['data'].indexOf('behavior') > -1">
          <el-submenu index="/data/behavior">
            <template slot="title">
              <i class="fa c-icon fa-compass"></i>
              <span>行为</span>
            </template>
            <div><el-menu-item index="/data/behavior/mp">公众号</el-menu-item></div>
            <div><el-menu-item index="/data/behavior/h5">H5</el-menu-item></div>
            <div><el-menu-item index="/data/behavior/link">链接跳转</el-menu-item></div>
          </el-submenu>
        </div>
        <div v-if="menu['data'].indexOf('content') > -1">
          <!-- <el-menu-item index="/data/content/index">
            <i class="fa c-icon fa-file-text"></i>
            <span>内容</span>
          </el-menu-item> -->
          <el-submenu index="/data/content">
            <template slot="title">
              <i class="fa c-icon fa-file-text"></i>
              <span>内容</span>
            </template>
            <div><el-menu-item index="/data/content/index">概览</el-menu-item></div>
            <div><el-menu-item index="/data/content/details">详情</el-menu-item></div>
            <!-- <div><el-menu-item index="/data/content/tags">标签</el-menu-item></div> -->
          </el-submenu>
        </div>
        <div v-if="menu['data'].indexOf('mini') > -1">
          <el-menu-item index="/data/mini/overview">
            <template slot="title">
              <i class="fa c-icon fa-pie-chart"></i>
              <span>数据概览</span>
            </template>
          </el-menu-item>
        </div>
        <div v-if="menu['data'].indexOf('mini_realtime') > -1">
          <el-menu-item index="/data/mini_realtime/overview">
            <template slot="title">
              <i class="fa c-icon fa-clock-o"></i>
              <span>实时数据</span>
            </template>
          </el-menu-item>
        </div>
        <div v-if="menu['data'].indexOf('mini_user') > -1">
          <el-submenu index="/data/mini_user">
            <template slot="title">
              <i class="fa c-icon fa-user-circle"></i>
              <span>用户</span>
            </template>
            <div><el-menu-item index="/data/mini_user/overview">概览</el-menu-item></div>
            <div><el-menu-item index="/data/mini_user/loyalty">忠诚度</el-menu-item></div>
            <div><el-menu-item index="/data/mini_user/keep">用户留存</el-menu-item></div>
            <div><el-menu-item index="/data/mini_user/location">地域分析</el-menu-item></div>
            <div><el-menu-item index="/data/mini_user/brand">手机品牌</el-menu-item></div>
            <div><el-menu-item index="/data/mini_user/system">操作系统</el-menu-item></div>
            <div><el-menu-item index="/data/mini_user/details">用户详情</el-menu-item></div>
          </el-submenu>
        </div>
        <div v-if="menu['data'].indexOf('mini_behavior') > -1">
          <el-submenu index="/data/mini_behavior">
            <template slot="title">
              <i class="fa c-icon fa-compass"></i>
              <span>行为</span>
            </template>
            <div><el-menu-item index="/data/mini_behavior/overview">启动行为分析</el-menu-item></div>
            <div><el-menu-item index="/data/mini_behavior/custom">自定义事件分析</el-menu-item></div>
            <div><el-menu-item index="/data/mini_behavior/interview">页面分析</el-menu-item></div>
            <div><el-menu-item index="/data/mini_behavior/channel">渠道分析</el-menu-item></div>
            <div><el-menu-item index="/data/mini_behavior/scene">场景值分析</el-menu-item></div>
            <div><el-menu-item index="/data/mini_behavior/share">分享行为分析</el-menu-item></div>
            <div v-if="$store.state.user['content_hub_id'] !== ''"><el-menu-item index="/data/mini_behavior/article">文章分析</el-menu-item></div>
          </el-submenu>
        </div>
      </div>
      <div class="line"></div>
    </div>

    <div>
      <div v-if="menu['mp']">
        <el-submenu index="/mp">
          <template slot="title">
            <i class="fa fa-wechat c-icon"></i>
            <span class="menu-title">微信公众号设置</span>
          </template>
          <div v-if="menu['mp'].indexOf('material') > -1">
            <el-submenu index="/mp/material">
              <template slot="title"><span>微信素材管理</span></template>
              <div><el-menu-item index="/mp/material/picture">图片</el-menu-item></div>
              <div><el-menu-item index="/mp/material/video">视频</el-menu-item></div>
              <div><el-menu-item index="/mp/material/audio">音频</el-menu-item></div>
              <div><el-menu-item index="/mp/material/article">图文</el-menu-item></div>
              <div><el-menu-item index="/mp/material/drafts">草稿箱</el-menu-item></div>
              <div><el-menu-item index="/mp/material/material">已发布素材</el-menu-item></div>
            </el-submenu>
          </div>
          <div v-if="menu['mp'].indexOf('reply') > -1">
            <el-submenu index="/mp/reply">
              <template slot="title"><span>回复素材管理</span></template>
              <div><el-menu-item index="/mp/reply/article">外链图文</el-menu-item></div>
              <div><el-menu-item index="/mp/reply/video">本地视频</el-menu-item></div>
              <div><el-menu-item index="/mp/reply/text">文本</el-menu-item></div>
              <div><el-menu-item index="/mp/reply/mini">小程序</el-menu-item></div>
            </el-submenu>
          </div>
          <div v-if="menu['mp'].indexOf('menu') > -1">
            <el-submenu index="/mp/menu">
              <template slot="title"><span>菜单管理</span></template>
              <div><el-menu-item index="/mp/menu/layout">个性化菜单</el-menu-item></div>
              <div><el-menu-item index="/mp/menu/release">菜单发布</el-menu-item></div>
            </el-submenu>
          </div>
          <div v-if="menu['mp'].indexOf('group') > -1">
            <el-submenu index="/mp/group">
              <template slot="title"><span>用户分组管理</span></template>
              <div><el-menu-item index="/mp/group/index">分组管理</el-menu-item></div>
              <div><el-menu-item index="/mp/group/user">用户分组</el-menu-item></div>
            </el-submenu>
          </div>
          <div v-if="menu['mp'].indexOf('system') > -1">
            <el-submenu index="/mp/system">
              <template slot="title"><span>基础功能</span></template>
              <div><el-menu-item index="/mp/system/reply">欢迎语管理</el-menu-item></div>
              <div><el-menu-item index="/mp/system/qrcode">二维码管理</el-menu-item></div>
              <div><el-menu-item index="/mp/system/mass">文章素材群发</el-menu-item></div>
              <!-- <div><el-menu-item index="/mp/system/shorturl">微信短链接</el-menu-item></div> -->
            </el-submenu>
          </div>
          <div v-if="menu['mp'].indexOf('custom') > -1">
            <el-submenu index="/mp/custom">
              <template slot="title"><span>高级功能</span></template>
              <div><el-menu-item index="/mp/custom/template">模板消息群发</el-menu-item></div>
              <div><el-menu-item index="/mp/custom/message">客服消息群发</el-menu-item></div>
              <div><el-menu-item index="/mp/custom/package">人群包管理</el-menu-item></div>
              <div><el-menu-item index="/mp/custom/track_reply">自动化营销设置</el-menu-item></div>
              <div><el-menu-item index="/mp/custom/user_tag">用户标签管理</el-menu-item></div>
            </el-submenu>
          </div>
        </el-submenu>
      </div>
    </div>
 
    <div>
      <div v-if="menu['package']">
        <el-submenu index="/package">
          <template slot="title">
            <i class="fa fa-wechat c-icon"></i>
            <span class="menu-title">人群包管理</span>
          </template>
          <div v-if="menu['package'].indexOf('package_filter') > -1">
            <div><el-menu-item index="/package/package_filter">人群包筛选</el-menu-item></div>
          </div>
          <div v-if="menu['package'].indexOf('sp_package_filter') > -1">
            <div><el-menu-item index="/package/sp_package_filter">人群包筛选</el-menu-item></div>
          </div>
        </el-submenu>
      </div>
    </div>
   
    <div>
      <div v-if="menu['setting']">
        <el-submenu index="/setting">
          <template slot="title">
            <i class="fa fa-cog c-icon"></i>
            <span class="menu-title">应用设置</span>
          </template>
          <div v-if="menu['setting'].indexOf('track') > -1 && String($store.state.authorizer.service_type_info['id']) === '2'">
            <el-submenu index="/setting/track">
              <template slot="title"><span>监控管理</span></template>
              <div><el-menu-item index="/setting/track/group">分组管理</el-menu-item></div>
              <div><el-menu-item index="/setting/track/link">跳转链接管理</el-menu-item></div>
              <div><el-menu-item index="/setting/track/event">H5事件管理</el-menu-item></div>
              <div><el-menu-item index="/setting/track/shortlink">短链接</el-menu-item></div>
            </el-submenu>
          </div>
          <div v-if="menu['setting'].indexOf('tag') > -1">
            <el-submenu index="/setting/tag">
              <template slot="title"><span>标签设置</span></template>
              <div><el-menu-item index="/setting/tag/type">标签分类</el-menu-item></div>
              <div><el-menu-item index="/setting/tag/manage">标签管理</el-menu-item></div>
            </el-submenu>
          </div>
          <div v-if="menu['setting'].indexOf('mini') > -1">
            <el-submenu index="/setting/mini">
              <template slot="title"><span>小程序设置</span></template>
              <div><el-menu-item index="/setting/mini/group">分组管理</el-menu-item></div>
              <div><el-menu-item index="/setting/mini/custom">自定义事件</el-menu-item></div>
              <div><el-menu-item index="/setting/mini/channel">来源管理</el-menu-item></div>
              <div v-if="has"><el-menu-item index="/setting/mini/scheme">URL Scheme</el-menu-item></div>
              <div v-if="has"><el-menu-item index="/setting/mini/link">URL Link</el-menu-item></div>
            </el-submenu>
          </div>
          <div v-if="menu['setting'].indexOf('app') > -1">
            <el-submenu index="/setting/app">
              <template slot="title"><span>APP设置</span></template>
              <div><el-menu-item index="/setting/app/group">分组管理</el-menu-item></div>
              <div><el-menu-item index="/setting/app/custom">自定义事件</el-menu-item></div>
            </el-submenu>
          </div>
          <div v-if="menu['setting'].indexOf('utm') > -1">
            <el-submenu index="/setting/utm">
              <template slot="title"><span>京东活动管理</span></template>
              <div><el-menu-item index="/setting/utm/group">活动分组管理</el-menu-item></div>
              <div><el-menu-item index="/setting/utm/link">活动链接管理</el-menu-item></div>
            </el-submenu>
          </div>
        </el-submenu>
      </div>
    </div>
    
    <div>
      <div v-if="menu['system']">
        <el-submenu index="/system">
          <template slot="title">
            <i class="fa fa-windows c-icon"></i>
            <span class="menu-title">系统管理</span>
          </template>
          <div v-if="menu['system'].indexOf('system') > -1"><el-menu-item index="/system/system/customer">客户管理</el-menu-item></div>
          <div v-if="menu['system'].indexOf('system') > -1"><el-menu-item index="/system/system/authorizer">公众号管理</el-menu-item></div>
          <div v-if="menu['system'].indexOf('system') > -1"><el-menu-item index="/system/system/mini">小程序管理</el-menu-item></div>
          <div v-if="menu['system'].indexOf('system') > -1"><el-menu-item index="/system/system/app">APP管理</el-menu-item></div>
          <div v-if="menu['system'].indexOf('system') > -1"><el-menu-item index="/system/system/tenant">京东租户管理</el-menu-item></div>
          <div v-if="menu['system'].indexOf('system') > -1"><el-menu-item index="/system/system/user">用户管理</el-menu-item></div>
        </el-submenu>
      </div>
    </div>
  </el-menu>
</template>
<script>
export default {
  props: [
    'defaultActive',
    'menu'
  ],
  data () {
    return {
      has: false
    }
  },
  created () {
    if (this.$store.state.authorizer["type"] == "sp") {
      let has = !!this.$store.state.authorizer.func_info.find(item => {
        return String(item["funcscope_category"]["id"]) === "88"
      })
      this.has = has
    }
  }
}
</script>
<style>
</style>
